function getReceivingMonthAndYearFrom(currDateStr, creditMonths) {
	const currTurnDate = new Date(currDateStr);

	const currMonth = currTurnDate.getMonth() + 1;
	let receivingMonth = currMonth + creditMonths;
	let receivingYear = currTurnDate.getFullYear();

	if (receivingMonth > 12) {
		receivingYear = receivingYear + 1;
		receivingMonth = receivingMonth - 12;
	}

	return { receivingMonth, receivingYear };
}

export {
	getReceivingMonthAndYearFrom
};
